<template>
  <!-- 活动图片列表 -->
  <div class="page activity-picture-list">
    <div class="container">
      <div class="showcase">
        <div class="goods-list">
          <div class="goods-item" v-for="(item, index) in listData" :key="index">
            <div class="goods-item-img">
              <template>
                <div class="goods-img" @click="todetail(item, index)">
                  <el-image class="image" :src="item.cover" @error="handleError" />
                </div>
              </template>
            </div>
            <div class="goods-item-info">
              <div class="title ellipsis">{{ item.title }}</div>
            </div>
          </div>
        </div>
        <div class="elpagination">
          <div class="elpagination-title">共{{ total }}条</div>
          <el-pagination background layout="prev, pager, next, jumper" prev-text="上一页" next-text="下一页" :total="total"
            :current-page="queryParams.page" :page-size="queryParams.per_page"
            @current-change="pageChange"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getActivePictureList } from "@/api/activity"
export default {
  name: "ActivePictureList",
  components: {},
  data() {
    return {
      goodsimage: require("@/assets/default/image02.jpg"),
      listData: [],
      collegelist: [],
      queryParams: {
        keyword: "",
        per_page: 16,
        page: 1,
      },
      total: 0,
      image3: require("@/assets/new/people.png"),
      testimage: require("@/assets/default/test.png"),
      testimageicon: require("@/assets/icon/title.png"),
      goodsimage: require("@/assets/default/image02.jpg"),
    }
  },
  computed: {},
  created() { },
  mounted() {
    this.getList()
  },
  methods: {
    // 获取列表数据
    getList() {
      getActivePictureList(this.queryParams).then((res) => {
        if (res.code === 0) {
          const newData = res.data?.data ?? []
          this.total = res.data?.total ?? 0
          this.listData = newData
        }
      }).catch(() => { })
    },
    handleError(e) {
      e.target.src = this.goodsimage
    },
    //页码发生改变时
    pageChange(val) {
      this.queryParams.page = val
      this.getList()
    },
    todetail(item, inx) {
      window.localStorage.setItem("menuId", 3)
      this.$store.dispatch("setmenuid", 3)
      this.$router.push({
        path: "/home/album/detail",
        query: {
          id: item.id,
          index: inx,
          cPage: this.queryParams.page
        },
      })
    },
  },
};
</script>
<style scoped lang="scss">
.page {
  width: 100%;
  max-width: 1800px;
  margin: 0 auto 40px;
  overflow: hidden;

  .container {
    margin-top: 30px;

    .showcase {
      margin: 0 -10px;

      .goods-list {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;

        .goods-item {
          width: calc((100% - 90px) / 4);
          height: 320px;
          background-color: #fff;
          border: 1px solid transparent;
          border-radius: 5px;
          overflow: hidden;
          position: relative;
          margin: 10px 10px;
          flex-shrink: 1;
          cursor: pointer;

          .goods-item-img {
            position: relative;

            .goods-img {
              width: 100%;
              height: 320px;
              background: aliceblue;

              .image {
                display: inline-block;
                -webkit-transition-duration: 0.3s;
                transition-duration: 0.3s;
                -webkit-transition-property: transform;
                transition-property: transform;
                -webkit-transform: translateZ(0);
                transform: translateZ(0);
                box-shadow: 0 0 1px rgba(0, 0, 0, 0);
              }

              .image:hover,
              .image:focus,
              .image:active {
                -webkit-transform: scale(1.1);
                transform: scale(1.1);
              }

              .image {
                width: 100%;
                height: 100%;
              }
            }

            .default-img {
              width: 100%;
              height: 320px;
              text-align: center;
              background: aliceblue;

              .image {
                display: inline-block;
                -webkit-transition-duration: 0.3s;
                transition-duration: 0.3s;
                -webkit-transition-property: transform;
                transition-property: transform;
                -webkit-transform: translateZ(0);
                transform: translateZ(0);
                box-shadow: 0 0 1px rgba(0, 0, 0, 0);
              }

              .image:hover,
              .image:focus,
              .image:active {
                -webkit-transform: scale(1.1);
                transform: scale(1.1);
              }

              .image {
                width: 100%;
                height: 100%;
              }
            }
          }

          .goods-item-info {
            width: 100%;
            height: 40px;
            line-height: 20px;
            padding: 10px 15px;
            background-color: rgba(0, 0, 0, 0.4);
            box-sizing: border-box;
            position: absolute;
            z-index: 9;
            bottom: 0;

            .title {
              color: #fff;
              font-size: 16px;
              font-weight: 400;
            }
          }
        }
      }

      .elpagination {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin: 30px 5px 0px 0px;

        .elpagination-title {
          margin-right: 10px;
        }
      }
    }
  }
}

@media screen and (max-width: 640px) {
  .activity-picture-list {
    max-width: 640px;
    // padding: 0 10px;
    box-sizing: border-box;

    .container {
      .showcase {
        margin: 0;

        .goods-list {
          .goods-item {
            width: calc((100% - 25px) / 2);
            height: auto;
            margin: 5px;

            .goods-item-img {
              .goods-img {
                height: 180px;
              }

              .default-img {
                height: 180px;
              }
            }

            .goods-item-info {
              position: relative;

              .title {
                font-size: 13px;
              }
            }
          }

          // .goods-item:nth-child(2n + 1) {
          //   margin-left: 0;
          // }
        }

        .elpagination {
          // flex-direction: column;
          align-items: flex-start;
          justify-content: center;

          .elpagination-title {
            margin-bottom: 10px;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 640px) and (max-width: 1200px) {
  .activity-picture-list {
    max-width: 1200px;

    .container {
      .showcase {
        .goods-list {
          .goods-item {
            width: calc((100% - 90px) / 4);
            margin: 10px 10px;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 1200px) {
  .activity-picture-list {
    max-width: 1800px;

    .container {
      .showcase {
        .goods-list {
          .goods-item {
            width: calc((100% - 90px) / 4);
            margin: 10px 10px;
          }
        }
      }
    }
  }
}
</style>